import { Field } from "@/components/intake/StepContact";

function Row({ label, value }) {
  if (!value) return null;
  return (
    <div className="flex flex-col gap-0.5 py-2 sm:flex-row sm:gap-4">
      <dt className="w-32 shrink-0 text-xs font-bold uppercase tracking-wider text-zinc-500">{label}</dt>
      <dd className="text-sm font-semibold text-black">{value}</dd>
    </div>
  );
}

export function StepComment({ form, update, config }) {
  return (
    <div className="space-y-6">
      <h2 className="font-display text-2xl font-bold">Step 4 · Anything else?</h2>
      <Field label="Any other comment (optional)" testId="field-comment">
        <textarea
          className="field-input min-h-[140px] resize-y"
          placeholder="Share any details that will help us resolve this faster: payment ID, screenshots you've emailed, dates…"
          value={form.comment}
          onChange={(e) => update({ comment: e.target.value })}
          data-testid="comment-textarea"
          maxLength={3000}
        />
      </Field>

      <dl className="rounded-xl border-2 border-dashed border-zinc-400 bg-zinc-50 px-4 py-2 divide-y divide-zinc-200" data-testid="form-summary">
        <Row label="Name" value={form.name} />
        <Row label="Contact" value={`${form.phone} · ${form.email}`} />
        <Row label="Product" value={form.product} />
        {form.product === config.challenge_product && <Row label="Batch" value={form.batch_mode === "known" ? form.batch.toUpperCase() : config.batch_unknown} />}
        <Row label="Query" value={form.query} />
        {form.addons.length > 0 && <Row label="Add-ons" value={form.addons.join(", ")} />}
        <Row label="Indore classes" value={form.offline_interest ? "Yes, interested" : "No"} />
      </dl>
    </div>
  );
}
